/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Log_Toast_SavedInputs */

const vi_scl_log_toast_saved = /** @type {(inputs: Scl_Log_Toast_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã ghi vào sổ`)
};

/**

* @param {Scl_Log_Toast_SavedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_log_toast_saved = /** @type {((inputs?: Scl_Log_Toast_SavedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Log_Toast_SavedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_log_toast_saved(inputs)
});